import React from 'react';

import CountdownTimerComponent from '../../components/generalComponents/CountdownTimerComponent/CountdownTimerComponent';
import taglineLogo from '../../assets/createAccountPage/nn_taglinelogo_hd-7261aedcdab6423445387624801ca3e6.png';
import getAccess from '../../assets/createAccountPage/get_access-fb181c83daf3ff922d2a54508ca391d8.png';


function CheckoutHeader(props) {
  const { activeCampaign, anchorToSubscribe } = props;
  const { hasTimer, secondsLeft } = activeCampaign || {};

  return (
    <div id="navigation2">
      <nav
        className="navbar navbar-lg navbar-topnav navbar-static-top"
        id="header-nav"
        role="navigation"
      >
        <div className="container">
          <span className="navbar-brand">
            <a href="/">
              <img
                alt="Naked News: The Program With Nothing To Hide"
                src={taglineLogo}
                style={{ width: '100%' }}
              />
            </a>
          </span>
          <span className="pull-right visible-md visible-lg">
            <img
              alt="Get access"
              src={getAccess}
              style={{ padding: '29px 0' }}
            />
          </span>
          {!anchorToSubscribe && activeCampaign && hasTimer && secondsLeft &&
          <div className="pull-right timerArea">
            <CountdownTimerComponent activeCampaign={activeCampaign} />
          </div>
          }
        </div>
      </nav>
    </div>
  );
}

export default CheckoutHeader;
